import React from 'react';

const InfoBorderNotification = () => (
  <svg width="46" height="46" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <rect stroke="#EF7800" stroke-width="2" x="1" y="1" width="44" height="44" rx="22"/>
      <g fill="#EF7800">
        <path d="M24.028 33.583V16.512a1.014 1.014 0 1 0-2.028 0v17.071a1.014 1.014 0 1 0 2.028 0zM23.014 11.028a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5z"/>
      </g>
    </g>
  </svg>
)

export default InfoBorderNotification